<template>
  <ul class="nav-vertical nav-vertical--nested" style="display: block">
    <li
      v-for="(tag, index) in tags"
      :key="tag.id"
      :aria-label="`Filter Item tag: ${tag.text}`"
      class="nav-vertical__item flex-wrap cursor-pointer filterOptionListItem py-1"
    >
      <c-filter-item-tag
        v-bind="tag"
        :isFirstTag="index === 0"
        @reset-tag="onResetTag"
        @tag-selected="onTagSelected"
      ></c-filter-item-tag>
    </li>
  </ul>
</template>

<script>
import FilterItemTag from '@/components/pages/filter/categories/FilterItemTag.vue'

export default {
  components: { 'c-filter-item-tag': FilterItemTag },
  props: { tags: { required: true, type: Array } },
  methods: {
    getTagById(id) {
      return this.tags.find(c => c.id === id)
    },
    onResetTag() {
      this.$emit('reset-tag')
    },
    onTagSelected(e) {
      this.$emit('tag-selected', this.getTagById(e))
    },
  },
}
</script>
